import RepeatPatternSchedulingStrategyEditor from "../../../pages/actionModules/ActionModuleEditor/SchedulingStrategyEditor/RepeatPatternSchedulingStrategyEditor";
import { SchedulingStrategyDefinition } from "../actionModule";
import { ActionModuleFrequency, RepeatPatternSchedulingStrategyModel, SchedulingStrategyType } from "./schedulingStrategyType";

export const RepeatPatternSchedulingStrategy: SchedulingStrategyDefinition = {
    name: "actionModules.schedulingStrategy.repeatPattern.name",
    defaultValue: {
        frequency: ActionModuleFrequency.Weekly,
    } as RepeatPatternSchedulingStrategyModel,
    type: SchedulingStrategyType.RepeatPatternSchedulingStrategy,
    editor: (props) => <RepeatPatternSchedulingStrategyEditor {...props} />
}
